import React from "react";
import cn from "classnames";
import { Icon, P } from "src/components";

interface Props extends React.HTMLAttributes<HTMLParagraphElement> {}

const ErrorMessage: React.FC<Props> = ({ children, className, ...rest }) => {
  return (
    <div className="flex self-stretch gap-x-4 p-4 items-center border rounded-2xl bg-warning-light">
      <span className="flex w-10 h-10 items-center justify-center gap-2 shrink-0 rounded-full bg-[#FFF5E8]">
        <Icon icon="info" className="text-warning" />
      </span>
      <P className={className} {...rest}>
        {children}
      </P>
    </div>
  );
};

export default ErrorMessage;
